module.exports = __webpack_public_path__ + "static/media/14.1e8fc192.png";